import { cl, CustomElement } from '@/utils';
import { getGsap } from '@/gsap';
import { bus } from '@/bus';

export default class ListHover extends CustomElement {
  static component = 'b-list-hover';
  hover: HTMLElement;
  hoverEls: HTMLElement[] = [];
  init() {
    this.hover = this.$('hover');
    this.hoverEls = this.$$('hover-el');

    this.addEventListener('mouseleave', this.classRemover);

    bus.on('resize', this.classRemover);

    getGsap((gsap) => {
      this.hoverEls.forEach((el) => {
        el.addEventListener('mouseenter', () => {
          this.setHover(el, gsap);
        });
      });

      let activeIndex = -1;
      bus.on('scroll', () => {
        this.hoverEls.forEach((el, i) => {
          const { height, top } = el.getBoundingClientRect();
          if (
            top < window.innerHeight / 2 &&
            top + height > window.innerHeight / 2 &&
            activeIndex !== i
          ) {
            activeIndex = i;
            this.setHover(el, gsap);
          }
        });
      });
    });
  }

  classRemover = () => {
    cl(this).remove('has-hovered');
  };

  setHover(el: HTMLElement, gsap: GSAP) {
    cl(this.hoverEls).remove('hovered');
    const contTop = this.getBoundingClientRect().top;
    const { height, top } = el.getBoundingClientRect();
    const bg = el.style.getPropertyValue('--bg-color');
    const bgAlt = el.style.getPropertyValue('--bg-alt');

    cl(el).add('hovered');
    cl(this).add('has-hovered');

    if (bg) {
      this.style.setProperty('--bg-color', bg);
    } else {
      this.style.removeProperty('--bg-color');
    }

    if (bgAlt) {
      this.style.setProperty('--bg-alt', bgAlt);
    } else {
      this.style.removeProperty('--bg-alt');
    }

    gsap.to(this.hover, {
      y: Math.abs(contTop - top),
      height,
      duration: 0.5,
      ease: 'power2.out',
    });
  }

  setHovers(newEls: any[], replace = false) {
    cl(this).remove('has-hovered');
    getGsap((gsap) => {
      newEls.forEach((el) => {
        el.addEventListener('mouseenter', () => {
          this.setHover(el, gsap);
        });
      });
      if (replace) {
        this.hoverEls = newEls;
      } else {
        this.hoverEls.push(...newEls);
      }
    });
  }

  destroyed() {
    bus.off('resize', this.classRemover)
  }
}
